import React from 'react';

const TG = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_31"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_31)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="#FFD400"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 0H21V3H7V0ZM7 6H21V9H7V6ZM0 12H21V15H0V12Z"
        fill="#007558"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H9V9H0V0Z"
        fill="#D70F3B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.44 5.897L2.932 6.69L3.22 5.01L2 3.823L3.686 3.578L4.44 2.05L5.194 3.577L6.88 3.822L5.66 5.012L5.948 6.69"
        fill="white"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default TG;
